import * as React from 'react'

import Stack from '@mui/material/Stack'

import { CampaignTrackingActive } from './CampaignTrackingActive'
import { CampaignTrackingInactive } from './CampaignTrackingInactive'
import { CampaignTrackingProviderAlerts } from './CampaignTrackingProviderAlerts'
import { useGetCallTrackingProviders } from '../hooks/useGetCallTrackingProviders'
import { TidalCampaignTrackingCard } from './TidalCampaignTrackingCard'
import { TidalCampaignTrackingHeader } from './TidalCampaignTrackingHeader'
import { useSelector } from 'react-redux'

import { callTrackingProviderList } from '@user/store/callTracking'

export default function CampaignTrackingProvider() {
  const { callTrackingProviderStatus } = useGetCallTrackingProviders()
  const callTrackingProviders = useSelector(callTrackingProviderList)
  return (
    <Stack justifyContent={'center'} alignItems={'center'}>
      <CampaignTrackingProviderAlerts status={callTrackingProviderStatus} />
      {callTrackingProviderStatus === 'success' &&
        callTrackingProviders.map((provider) => {
          return (
            <TidalCampaignTrackingCard key={provider.id}>
              <TidalCampaignTrackingHeader
                name={provider.callTrackingProvider.name}
                synced={provider.synched}
              />
              {provider.synched ? (
                <CampaignTrackingActive
                  key={provider.id}
                  id={provider.callTrackingProvider.id}
                  name={provider.callTrackingProvider.name}
                  accountId={provider.callTrackingAccountId}
                  synced={provider.synched}
                />
              ) : (
                <CampaignTrackingInactive
                  key={provider.id}
                  id={provider.callTrackingProvider.id}
                  name={provider.callTrackingProvider.name}
                  accountId={provider.callTrackingAccountId}
                  synced={provider.synched}
                />
              )}
            </TidalCampaignTrackingCard>
          )
        })}
    </Stack>
  )
}
